import React from "react";

import "assets/css/componentStyles/FlowCard.css"
import 'reactflow/dist/style.css';
import 'react-loading-skeleton/dist/skeleton.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'assets/css/own.css'

import LoaderComponent from 'components/common/Loader';
import Login from "views/Login";
import AuthenticatedRoutes from "AuthenticatedRoutes";
import ThemeContextWrapper from "components/themeWrapper/ThemeWrapper";
import BackgroundColorWrapper from "components/BackgroundColorWrapper";
import { UserSettingsProvider } from "contexts/UserSettingsContext";
import { Route, Routes, Navigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { registerLicense } from '@syncfusion/ej2-base';
import { AbilityContext } from "abilities/AbilityProvider";
import { ability } from "abilities/AbilityProvider";
import AcceptInvitation from "components/modules/tenants/AcceptInvitation";

registerLicense(process.env.REACT_APP_SYNCFUSION_KEY);

export const App = () => {
    const { isAuthenticated, isLoading } = useAuth0();

    if(isLoading) return <LoaderComponent/>;
    if(!isAuthenticated){
        return (
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/invite" element={<AcceptInvitation/>}/>
                <Route path="*" element={
                    <Navigate to="/login" replace />
                }/>
            </Routes>
        )
    }

    return (
        <ThemeContextWrapper>
            <BackgroundColorWrapper>
                <UserSettingsProvider>
                    <AbilityContext.Provider value={ability}>
                        <AuthenticatedRoutes />
                    </AbilityContext.Provider>
                </UserSettingsProvider>
            </BackgroundColorWrapper>
        </ThemeContextWrapper>
    )
};
